import React, { FC, ReactElement, useCallback, useContext } from 'react'
import CLanguageHandler from '../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../../React/Common/Contexts'
import { signOut } from '../../../../../React/Common/API/UserSignInOutAPI'
import { redirectToServletWithBranding, ServletCmds } from '../../../../../NonReact/constants/ServletCommands'
import { PasswordChangeLanguage } from '../../../../../../i18n'
import { RoundedButton } from '../../../Atoms/RoundedButton/RoundedButton'
import { Branding } from '../../../../../React/Common/API/BrandingAPI'
import { useBranding } from '../../../../../React/Common/Hooks/useBranding'
import { APIElements } from '../../../../../NonReact/constants/ApiConstants'
import { UserInfo, useUserInfo } from '../../../../Hooks/useUserInfo'

type Props = {
    isSubmitEnabled: boolean
}

export const FooterActions: FC<Props> = ({ isSubmitEnabled }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const [userInfo]: UserInfo = useUserInfo()

    const branding: Nullable<Branding> = useBranding()

    const doCancel = useCallback((): void => {
        if (userInfo?.PasswordChgRequired) {
            signOut()
        } else {
            redirectToServletWithBranding(ServletCmds.MAIN_HOME, branding?.URLMapping ?? APIElements.AKIXI_2019)
        }
    }, [userInfo])

    return (
        <div className='pc-footer-actions'>
            <RoundedButton className='pc-cancel' type='button' onClick={doCancel}>
                {language.get(PasswordChangeLanguage.PasswordChange_Actions_Cancel)}
            </RoundedButton>
            <RoundedButton className='pc-submit' type='submit' disabled={!isSubmitEnabled}>
                {language.get(PasswordChangeLanguage.PasswordChange_Actions_ChangePassword)}
            </RoundedButton>
        </div>
    )
}
